var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[(_vm.user.image)?_c('img',{staticClass:"avatar__image",attrs:{"src":_vm.url,"alt":"Your picture","title":_vm.user.name}}):_c('div',{staticClass:"avatar__placeholder"},[_c('img',{staticClass:"avatar__image",attrs:{"src":"/img/app/avatar.png","alt":"Your picture","title":"No picture available"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }